module.exports = __webpack_public_path__ + "static/media/cumbicos.8c152ec4.jpg";